import styled from "styled-components";
import { motion } from "framer-motion";
import { space } from "styled-system";

import { getBorderColor, getThemeColor } from "./theme";
import { Variants } from "./types";

export const StyledAlertBanner = styled(motion.div)<{ variant?: Variants }>`
  background-color: ${({ theme }) => (theme.isDark ? getThemeColor({ theme }) + "20" : getThemeColor)};
  border: 1px solid ${getBorderColor};
  border-radius: ${({ theme }) => theme.radii.small};
  padding: 24px;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  ${space}
`;
